const totalControllerLength = 12;

export const generateSerialNumber = () => {
  const prefix = 'MIRA';
  const random = [...Array(6)].map(() => Math.random().toString(36)[2].toUpperCase()).join('');
  return `${prefix}-${random}`;
};

export const generateControllerSerialNumber = (serial_letters, serial_numbers) => {
  if (serial_letters?.length > 0 && serial_numbers?.length > 0) {
    const numbersLength = totalControllerLength - serial_letters.length;
    const paddedNumbers = String(serial_numbers).padStart(numbersLength, '0');
    return `${serial_letters}${paddedNumbers}`;
  } else {
    return `${serial_letters}${serial_numbers}`;
  }
};

export const checkControllerSerialNumber = (serial_number) => {
  return serial_number?.startsWith('WFK') || serial_number?.startsWith('NBK');
};
